var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "supportcontainer",
      staticClass: "grid gap-sm sm:gap-md grid-cols-12",
    },
    [
      _c("div", { staticClass: "hidden lg:block lg:col-span-1" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-span-12 lg:col-span-10" }, [
        _c("div", { staticClass: "w-full md:w-5/12 relative mb-md" }, [
          _c(
            "label",
            {
              staticClass: "font-semibold mb-xxs inline-block",
              attrs: { for: "location" },
            },
            [_vm._v("Locatie")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relative" },
            [
              _c("vue-google-autocomplete", {
                ref: "locationAutocomplete",
                staticClass: "form__input form__input--filled-dark",
                attrs: {
                  id: "location",
                  name: "searchQuery",
                  types: "",
                  placeholder: "Vul hier je postcode in",
                  country: ["be"],
                },
                on: { placechanged: _vm.getAddressData },
              }),
              _vm._v(" "),
              _vm._m(0),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex flex-wrap gap-sm items-center justify-start mb-lg",
          },
          [
            _vm._l(_vm.categories, function (item, index) {
              return [
                item.count > 0
                  ? _c(
                      "a",
                      {
                        key: index,
                        staticClass:
                          "py-xxs px-xs text-xs uppercase hover:text-primary-400 hover:border-primary-400 text-gray-500 border transition-colors inline-flex border-gray-600 text-opacity-80 tracking-[2px] font-semibold cursor-pointer select-none",
                        class: {
                          "bg-primary-400 !text-gray-800":
                            _vm.active_categories.includes(item.id),
                        },
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.filter(item.id)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.name) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { key: "loading", staticClass: "flex justify-center" }, [
              _vm._m(1),
            ])
          : _c(
              "div",
              {
                staticClass:
                  "grid grid-cols-12 gap-x-md md:gap-x-0 gap-y-lg md:gap-y-xl",
              },
              [
                _vm._l(_vm.sortedArticles, function (article) {
                  return _c(
                    "div",
                    {
                      key: article.id,
                      staticClass: "col-span-6 md:col-span-4 md:hidden",
                    },
                    [
                      _c("supportitem", {
                        attrs: {
                          content: article,
                          "distance-object": _vm.getDistanceForId(article.id),
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.articleChunks, function (chunk, chunkindex) {
                  return _c(
                    "div",
                    {
                      key: "chunk-" + chunkindex,
                      staticClass:
                        "col-span-12 hidden md:grid grid-cols-12 gap-y-lg md:gap-y-xl gap-x-md",
                      class: chunkindex % 2 === 0 ? "sm:pr-lg" : "sm:pl-lg",
                    },
                    _vm._l(chunk, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "col-span-6 md:col-span-4",
                        },
                        [
                          _c("supportitem", {
                            attrs: {
                              content: item,
                              "distance-object": _vm.getDistanceForId(item.id),
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  )
                }),
                _vm._v(" "),
                !_vm.distances
                  ? _c(
                      "div",
                      { staticClass: "col-span-12" },
                      [
                        _c("pagination", {
                          attrs: {
                            "current-page": _vm.params.page,
                            "total-pages": _vm.totalPages,
                          },
                          on: {
                            "next-page": function ($event) {
                              return _vm.filter(null, _vm.params.page + 1)
                            },
                            "previous-page": function ($event) {
                              return _vm.filter(null, _vm.params.page - 1)
                            },
                            "go-to-page": function (event) {
                              return _vm.filter(null, event.page)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "absolute right-sm top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none",
      },
      [_c("i", { staticClass: "fa-regular fa-search" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center",
      },
      [
        _c("i", {
          staticClass:
            "fa-regular fa-spinner-third h-[60px] w-auto animate-spin",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }